import React from 'react';
import './thankyou.css';

function ThankYouPage() {
  return (
    <section className="thank-you-page">
      <div className="thank-you-content">
        <h1>Köszönjük!</h1>
        <p>
          Köszönjük, hogy elküldted a jelentkezésed.  
          Hamarosan felvesszük veled a kapcsolatot a további részletekért.
        </p>
        <p>
          Addig is, ha bármi kérdésed van, írj nekünk az
          <a href="mailto:info@csaszartravel.hu"> info@csaszartravel.hu</a> címre.
        </p>
        <button onClick={() => window.location.href = '/'}>Vissza a főoldalra</button>
      </div>
    </section>
  );
}

export default ThankYouPage;
